"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("../constant");
var _constant3 = require("./constant");
var _default = {
  PropTypes: {
    data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      emoji_inactive: _propTypes.string,
      emoji_active: _propTypes.string,
      value: _propTypes.any
    })),
    minText: _propTypes.string,
    maxText: _propTypes.string,
    textColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    textSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE),
    defaultValue: _propTypes.any,
    onEmojiClicked: _propTypes.func,
    fullWidth: _propTypes.bool,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    setActionName: _propTypes.func
  },
  DefaultProps: {
    data: _constant3.EMOJI_SCORING_DATA,
    minText: _constant3.MIN_TEXT,
    maxText: _constant3.MAX_TEXT,
    textColor: _constant3.TEXT_COLOR,
    textSize: _constant3.TEXT_SIZE,
    fullWidth: false,
    viewPort: _constant2.DEVICE_TYPE.DESKTOP,
    theme: _constant.DEFAULT_THEME,
    accessible: true
  }
};
exports.default = _default;